class MegaMenuShopAll extends HTMLElement {
  connectedCallback() {
    this.links = Array.from(this.querySelectorAll('.mega-menu-shop-all__link'));
    this.items = Array.from(this.querySelectorAll('.mega-menu-shop-all__item'));
    this.panels = Array.from(this.querySelectorAll('.mega-menu-shop-all__panel'));
    this.products = Array.from(this.querySelectorAll('.mega-menu-shop-all__product'));

    this.links.forEach((link) => {
      link.addEventListener('mouseenter', () => this.activate(link));
      link.addEventListener('focus', () => this.activate(link));
    });

    this.products.forEach((product) => {
      product.addEventListener('mouseenter', () => product.classList.add('is-hovered'));
      product.addEventListener('mouseleave', () => product.classList.remove('is-hovered'));
    });
  }

  activate(link) {
    const targetId = link.dataset.target;
    if (!targetId) return;

    this.items.forEach((item) => item.classList.remove('is-active'));
    const activeItem = link.closest('.mega-menu-shop-all__item');
    if (activeItem) activeItem.classList.add('is-active');

    this.panels.forEach((panel) => {
      panel.classList.toggle('is-active', panel.id === targetId);
    });
  }
}

if (!customElements.get('mega-menu-shop-all')) {
  customElements.define('mega-menu-shop-all', MegaMenuShopAll);
}
